import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import alertify from "alertifyjs"

import { dtg, storage } from '../firebase';
import { setProduct2d } from '../redux/actions/product2dActions';
import { addProductArray } from '../redux/actions/products';
import { setHourglassState } from '../redux/actions/hourglassAction';

export const useFirebaseDtgData = (iFrameData, setDisplay,setStyleToApply) => {
    const [productData, setProductData] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        if (iFrameData) {
            if (iFrameData?.cssLink) {
                const link = document.createElement('link');
                link.rel = "stylesheet";
                link.type = "text/css";
                link.href = iFrameData.cssLink;
                fetch(iFrameData.cssLink)
                .then(res => {
                    if (res.status === 200) {
                        document.head.appendChild(link);
                        setStyleToApply("custom");
                        link.onload = function () {
                            setDisplay(true);
                        }
                    } else {
                        console.log("Csslink not reachable!");
                        setDisplay(true);
                    }
                })
                .catch(err => {
                    console.log("Csslink doesn't exist!");
                    setDisplay(true);
                })
            } else {
                setDisplay(true)
            }
        }
    }, [iFrameData])

    //todo: add hourglass
    useEffect(() => {
        const setUpDtgData = async () => {
            try {
        if (iFrameData && iFrameData.selectedProd) {
                    dispatch(setHourglassState(true));

            const { productSKU, variationSKU, skuArray } = iFrameData.selectedProd;

            const dtgProductQuery = dtg
                .doc(iFrameData.apiKey)
                .collection("DTG")
                .doc(productSKU);

            const dtgViewsCollectionQuery = dtgProductQuery.collection("Views");

                    const views = await dtgViewsCollectionQuery.get();

            const viewDetails = []

                views.forEach((view) => {
                    viewDetails.push(new Promise((resolve, reject) => {
                        dtgViewsCollectionQuery.doc(view.id).get().then((result) => {

                            const { mockup, number } = result.data();

                            storage.refFromURL(mockup).getDownloadURL().then((svg)=>{
                                resolve({
                                    side: view.id,
                                    svg,
                                    order: number,
                                })
                            })
                        })
                    }))
                })

                    const result = await dtgProductQuery.get();

                    const allSKUs = skuArray;

                    const productSpecificSkuArray = allSKUs.filter((item)=>{
                        return item.parentSKU === productSKU
                    })

                const product = {
                    productSKU,
                    name: result.data().name,
                        skuArray: productSpecificSkuArray
                };

                    const details = await Promise.all(viewDetails);

                    details.sort((view1, view2) => view1.order - view2.order)

                    productSpecificSkuArray.sort((sku1, sku2)=>sku1.sizePosition - sku2.sizePosition)

                    product.sortedViews = details;

                    const sizeColorMapping = {}

                    product.skuArray.forEach(item=>{
                        if(!sizeColorMapping[item.size]){
                            sizeColorMapping[item.size]=[]
                        }

                        sizeColorMapping[item.size].push({
                            color: item.color,
                            colorName: item.colorName
                        })
                    })

                    product.sizeColorMapping = sizeColorMapping

                    setProductData(product)

                    dispatch(addProductArray(product));

                    console.log(product)

                    const selectedSku = product.skuArray.find((item) => item.sku === variationSKU)

                    console.log(selectedSku)

                    if (selectedSku) {

                        const selection = {
                            variationSKU,
                            name: product.name,
                            size: selectedSku.size,
                            price: selectedSku.price,
                            color: selectedSku.color,
                            parts: product.sortedViews.map((view) => ({
                                name: view.side,
                                image: view.svg,
                            }))
                        }

                        console.log(selection)

                        dispatch(setProduct2d(selection))
                    } else {
                        alertify.error("sku not found")
                    }
                }
            } catch (error) {
                console.error(error)
                alertify.error("something went wrong")
            } finally {
                dispatch(setHourglassState(false))
            }
        }

        setUpDtgData();
    }, [iFrameData])

    return productData;
}